import React from 'react';
import { cn } from '@/lib/utils';
import type { PresenceStatus } from '../types';

// Task #1660 — pallino presence sull'avatar. Mapping colori:
//   online  → emerald (verde)
//   away    → amber (giallo)
//   in-call → red (rosso) — utente in videocall LiveKit attiva
//   dnd     → violet (viola) — Do Not Disturb attivo
//   offline → grigio (nascosto di default)

const STATUS_COLOR: Record<PresenceStatus, string> = {
  online: 'bg-emerald-500',
  away: 'bg-amber-400',
  'in-call': 'bg-red-500',
  dnd: 'bg-violet-500',
  offline: 'bg-gray-300 dark:bg-gray-600',
};

const STATUS_LABEL: Record<PresenceStatus, string> = {
  online: 'Online',
  away: 'Assente',
  'in-call': 'In chiamata',
  dnd: 'Non disturbare',
  offline: 'Offline',
};

interface Props {
  status: PresenceStatus | null;
  size?: 'sm' | 'md';
  hideOffline?: boolean;
}

export function PresenceDot({ status, size = 'sm', hideOffline = true }: Props) {
  if (!status) return null;
  if (status === 'offline' && hideOffline) return null;
  const cls = STATUS_COLOR[status];
  const dim = size === 'sm' ? 'h-2.5 w-2.5' : 'h-3 w-3';
  return (
    <span
      title={STATUS_LABEL[status]}
      className={cn('absolute bottom-0 right-0 rounded-full border-2 border-white dark:border-gray-900 shadow-sm', dim, cls)}
    />
  );
}

export function statusLabel(status: PresenceStatus | null): string {
  return status ? STATUS_LABEL[status] : '—';
}
